import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoLoader from '@/components/LogoLoader';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) return <LogoLoader message="Preparing your UTIS workspace..." fullscreen />;
  if (!token) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;
